import truncate from "lodash/truncate"
import { Component } from "react"
import PropTypes from "prop-types"
import { withLDConsumer } from "launchdarkly-react-client-sdk"
import getContentUrl from "utils-lib/getContentUrl"
import { wmColor } from "themes-lib/wmTheme"
import { getWindow } from "utils-lib/getWindow"
import getAlertVersion from "utils-lib/alerts"
import Typography from "component-lib/Base/components/Typography"
import { Button } from "../../../../../Base"
import "./PrivacyAlert.scss"

const ssrWindow = getWindow()

const ALERT_VERSION = getAlertVersion()
const LOCAL_STORAGE_KEY = `${ALERT_VERSION}-alreadyVisited`
const isMobile = ssrWindow.innerWidth <= 768

const PRIVACY_DATA = {
  title: "WM US Privacy Policy Update",
  subtext: "Privacy Policy Update effective November 6, 2025.",
  linktext: "Privacy Policy",
  href: getContentUrl("/us/en/privacy"),
}

class PrivacyAlert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: true,
      localFlags: {
        LDFFEnableBanneronPages: this.props.ldClient?.variation(
          "LDFFEnableBanneronPages",
          false,
        ),
        LDFFReleaseFixprivacybanner: this.props.ldClient?.variation(
          "LDFFReleaseFixprivacybanner",
          false,
        ),
      },
    }
  }

  isNotificationHidden = (subtext) => {
    const visitedAlerts = localStorage.getItem(LOCAL_STORAGE_KEY)

    let parseVisitedAlerts = {}
    if (visitedAlerts) {
      try {
        parseVisitedAlerts = JSON.parse(visitedAlerts)

        const hasAlertBeenSeen = Boolean(parseVisitedAlerts?.[subtext])

        if (hasAlertBeenSeen) {
          return true
        }
      } catch {
        /* do nothing, use default parseVisitedAlerts value */
      }
      return false
    }
    return false
  }

  hideNotification(subtext) {
    const visitedAlerts = localStorage.getItem(LOCAL_STORAGE_KEY)

    let newVisitedAlerts = { [subtext]: true }
    if (visitedAlerts) {
      try {
        newVisitedAlerts = { ...newVisitedAlerts, ...JSON.parse(visitedAlerts) }
      } catch (e) {
        /* do nothing, use default newVisitedAlerts value */
      }
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newVisitedAlerts))

    this.setState(
      {
        isVisible: false,
      },
      () => {
        this.props.onAlertClose()
      },
    )
  }

  componentDidUpdate() {
    if (this.props.ldClient) {
      const LDFFEnableBanneronPages = this.props.ldClient?.variation(
        "LDFFEnableBanneronPages",
        false,
      )
      const LDFFReleaseFixprivacybanner = this.props.ldClient?.variation(
        "LDFFReleaseFixprivacybanner",
        false,
      )
      if (
        LDFFEnableBanneronPages !==
          this.state.localFlags.LDFFEnableBanneronPages ||
        LDFFReleaseFixprivacybanner !==
          this.state.localFlags.LDFFReleaseFixprivacybanner
      ) {
        this.setState((prevState) => ({
          localFlags: {
            ...prevState.localFlags,
            LDFFEnableBanneronPages,
            LDFFReleaseFixprivacybanner,
          },
        }))
      }
    }
  }

  render() {
    if (
      !this.state.localFlags.LDFFEnableBanneronPages &&
      ssrWindow.location.pathname?.length > 7
    ) {
      return null
    }

    const { localFlags } = this.state
    const usePrivacyData = localFlags.LDFFReleaseFixprivacybanner
    const privacyData = usePrivacyData ? PRIVACY_DATA : this.props.minorAlerts
    const LDFFReleasePrivacyPolicyOverlappingIssue =
      this.props.ldClient?.variation(
        "LDFFReleasePrivacyPolicyOverlappingIssue",
        false,
      )
    if (privacyData) {
      const { title, linktext, href, subtext } = privacyData

      return this.state.isVisible &&
        subtext &&
        !this.isNotificationHidden(subtext) ? (
        <div
          className="PrivacyAlert"
          style={{
            background: wmColor.greenTint,
            position: "fixed",
            bottom: 0,
            width: "100%",
          }}
          data-testid="PrivacyAlert"
        >
          <div className="d-flex  position-relative wrap">
            <div className="container">
              <div
                data-testid="PrivacyMobile"
                className={`PrivacyMobile justify-content-between ${
                  LDFFReleasePrivacyPolicyOverlappingIssue
                    ? "PrivacyMobile--auto-rows"
                    : ""
                }`}
              >
                <img
                  className="info-logo"
                  src={getContentUrl(
                    `/content/dam/wm/icons/utilities/30x30/black/Info.svg`,
                  )}
                  alt="privacy Info"
                  width={30}
                  height={30}
                />
                <div
                  className="maax-font-weight-bold max-width "
                  style={{
                    color: wmColor.black,
                    fontSize: 16,
                    paddingLeft: 8,
                  }}
                >
                  <Typography
                    style={{
                      color: wmColor.black,
                      fontSize: isMobile ? "0.8rem" : "1rem",
                    }}
                    variant="h5"
                  >
                    {title}
                  </Typography>
                  <div
                    className="maax-font-weight-regular"
                    style={{
                      fontSize: isMobile ? "0.8rem" : "1rem",
                    }}
                  >
                    {truncate(subtext, {
                      length: 80,
                    })}
                  </div>
                </div>
                <div
                  className="d-inline-block MobilecloseButton"
                  data-testid="MobilecloseButton"
                >
                  <Button
                    alt={`close ${linktext} privacy alert`}
                    overrideClass="notification-close-btn d-flex justify-content-end position-relative pe-auto"
                    analytics_key={`close ${linktext} alert`}
                    onClick={() => {
                      this.hideNotification(subtext)
                    }}
                    ariaLabel={`close ${linktext} privacy alert`}
                    ariaHasPopup
                  >
                    <img
                      src={getContentUrl(
                        `/content/dam/wm/icons/controls/20x20/black/close-x.svg`,
                      )}
                      alt="privacy Info"
                      width={20}
                      height={20}
                    />
                  </Button>
                </div>
                {linktext && href && (
                  <div className="d-flex learnMoreTag">
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="a-taggable linkText quick-items ml-0 d-inline-block maax-font-weight-bold pe-auto"
                      style={{
                        fontSize: isMobile ? "0.8rem" : "1rem",
                        maxWidth: 250,
                      }}
                      data-testid="privacy-alert-learn-more-link"
                    >
                      {linktext}
                    </a>
                    <img
                      className="arrow-right"
                      src={getContentUrl(
                        `/content/dam/wm/icons/controls/20x20/green/material-ui/arrow-right.svg`,
                      )}
                      alt="privacy Info"
                      width={20}
                      height={20}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null
    }
    return null
  }
}

PrivacyAlert.propTypes = {
  /* AEM props. */
  minorAlerts: PropTypes.object,
  /* Props */
  onAlertClose: PropTypes.func.isRequired,
  ldClient: PropTypes.object,
}

PrivacyAlert.defaultProps = {
  minorAlerts: null,
  ldClient: null,
}

export default withLDConsumer()(PrivacyAlert)
